import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import _ from 'lodash'
import OnlinePaymentImg from '../../assets/static/images/online-payment.svg';
import SwipeCardMachineImg from '../../assets/static/images/card-swipe-machine.svg';
import { itrustPaySettingsLoad } from '../../redux/actions/addOns/itrustPay/itrustPayActions'

const EMPTY_OBJ = {}
const EMPTY_ARR = []


const useStoreAllowedPaymentMethods = (storeId) => {
  const dispatch = useDispatch()
  const storeAllowedPaymentMethods = useSelector(state => state.storeSetting.filtered_store_settings?.payment_method?.[0]?.store_config?.payment_methods || EMPTY_OBJ)
  const organisation = useSelector(state => state.organisation?.organisation)
  const itrustPaySettings = useSelector(state => state.itrustPay?.settings || EMPTY_ARR)
  const [paymentMode, setPaymentMode] = useState([])

  const resolvedStoreId = storeId || localStorage.getItem('StoreID')
  const itrustPayGateway = organisation?.add_ons_config?.type?.itrust_pay?.gateway
  const currentItrustPaySetting = itrustPaySettings.find(
    (setting) => String(setting.store_id) === String(resolvedStoreId)
  ) || itrustPaySettings[0]
  const authorizeStatus = currentItrustPaySetting?.config?.authorize?.status

  useEffect(() => {
    if (itrustPayGateway !== 'authorize' || !resolvedStoreId) return

    dispatch(itrustPaySettingsLoad({ store_id: resolvedStoreId, category: 'itrust_pay' }))
  }, [dispatch, itrustPayGateway, resolvedStoreId])

  useEffect(() => {
    if (_.isEmpty(storeAllowedPaymentMethods)) return

    const methods = [
      { value: 'card', label: `<i className="las la-hand-holding-usd mr-1"></i> Card`, hide: !storeAllowedPaymentMethods.card },
      { value: 'cash', label: '<i className="las la-money-bill-wave mt-2 mr-1"></i> Cash', hide: !storeAllowedPaymentMethods.cash },
      { value: 'check', label: `<i className="las la-money-check-alt mt-1 mr-1"></i> Check`, hide: !storeAllowedPaymentMethods.check },
      { value: 'zelle', label: `<i className="las la-money-check-alt mt-1 mr-1"></i> Zelle`, hide: !storeAllowedPaymentMethods.Zelle },
      { value: 'ach', label: `<i className="las la-money-check-alt mt-1 mr-1"></i> ACH`, hide: !storeAllowedPaymentMethods.ACH },
    ]

    const onlineMethods = [
      { value: 'online', label: `<img src=${OnlinePaymentImg} /> Online` },
      { value: 'device', label: `<img src=${SwipeCardMachineImg} /> Terminal` },
      { value: 'link', label: '<i className="las la-external-link-alt mt-1 mr-1"></i>Pay by Text' },
    ]

    const isItrustPayEnabled = organisation?.add_ons_config?.type?.itrust_pay?.status !== 'inactive'
      && organisation?.add_ons_config?.type?.itrust_pay?.visible === true
    const modes = isItrustPayEnabled && (itrustPayGateway !== 'authorize' || authorizeStatus === 'success')
      ? [...onlineMethods, ...methods]
      : methods

    setPaymentMode(modes.filter(item => item.hide !== true))
  }, [
    storeAllowedPaymentMethods,
    organisation,
    itrustPayGateway,
    authorizeStatus,
  ])

  return paymentMode
}

export default useStoreAllowedPaymentMethods
